import { hitKeeta3UIRefreshStrategy } from '../common/ABStrategy';

export enum IconKey {
  Default = 0,
  HOME = 1,
  OFFICE = 2,
  GATHERING = 3,
  OTHERS = 99,
  FACE_DELIVERY = 'faceDelivery',
  ASSIGNED_PLACE = 'assignedPlace'
}

enum IconVersion {
  Default = 'default',
  Global = 'global',
}

export function labelTypeToIconKey(labelType: number | undefined): IconKey | undefined {
  switch (labelType) {
    case 0:
      return IconKey.Default;
    case 1:
      return IconKey.HOME;
    case 2:
      return IconKey.OFFICE;
    case 3:
      return IconKey.GATHERING;
    case 99:
      return IconKey.OTHERS;
    default:
      return undefined;
  }
}

const iconPaths: Record<IconKey, Record<IconVersion, string>> = {
  [IconKey.Default]: {
    [IconVersion.Default]: 'assets://order/addr_logo_default.png',
    [IconVersion.Global]: 'assets://order/addr_logo_default_global.png',
  },
  [IconKey.HOME]: {
    [IconVersion.Default]: 'assets://address/icon_home.png',
    [IconVersion.Global]: 'assets://address/icon_home_global.png',
  },
  [IconKey.OFFICE]: {
    [IconVersion.Default]: 'assets://address/icon_office.png',
    [IconVersion.Global]: 'assets://address/icon_office_global.png',
  },
  [IconKey.GATHERING]: {
    [IconVersion.Default]: 'assets://address/icon_gathering.png',
    [IconVersion.Global]: 'assets://address/icon_gathering_global.png',
  },
  [IconKey.OTHERS]: {
    [IconVersion.Default]: 'assets://address/icon_others.png',
    [IconVersion.Global]: 'assets://address/icon_others_global.png',
  },
  [IconKey.FACE_DELIVERY]: {
    [IconVersion.Default]: 'assets://order/face_to_delivery.png',
    [IconVersion.Global]: 'assets://order/order_confirm/face_to_delivery_confirm_global.png',
  },
  [IconKey.ASSIGNED_PLACE]: {
    [IconVersion.Default]: 'assets://order/assigned_place.png',
    [IconVersion.Global]: 'assets://order/order_confirm/assigned_place_confirm_global.png',
  }
};

export function getIconPath(type: IconKey): string {
  const version = hitKeeta3UIRefreshStrategy() ? IconVersion.Global : IconVersion.Default;
  const typeIcons = iconPaths[type];
  if (!typeIcons) {
    throw new Error(`Unrecognized icon type: ${type}`);
  }
  const iconPath = typeIcons[version];
  if (!iconPath) {
    throw new Error(`Unrecognized icon version: ${version}`);
  }
  return iconPath;
}
